import React from 'react';
import { Button } from './ui/button';

interface QuizzAnswerOptionsProps {
  answers: string[];
  onAnswer: (answer: string) => void;
}

const QuizzAnswerOptions = (props: QuizzAnswerOptionsProps) => {
  const { answers, onAnswer } = props;
  const renderedAnswers = answers.map((answer) => (
    <Button
      key={answer}
      variant="secondary"
      className="font-mono font-bold sm:min-w-[100px]"
      onClick={() => onAnswer(answer)}
    >
      {answer}
    </Button>
  ));

  return (
    <div className="mt-12 flex flex-wrap items-center justify-center gap-2">
      {renderedAnswers}
    </div>
  );
};

export default QuizzAnswerOptions;
